module.exports = __webpack_public_path__ + "static/media/Redfaktor-16,66-Hz.d984746e.png";